import { render, staticRenderFns } from "./BaseGrid.vue?vue&type=template&id=5e59aba4&"
import script from "./BaseGrid.vue?vue&type=script&lang=js&"
export * from "./BaseGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports